import { ObjectDeleteByKey } from "utils/helpers";
import {
  DELETE_COLUMN,
  SET_COLUMN_SCHEME,
  LOAD_TAB_SETTINGS,
  CLEAR_TEMPORARY_SETTINGS,
  CREATE_SETTING_COLOR_SCHEME,
  SET_COLOR_PRIMARY_COLUMN,
  DELETE_SCHEME_SETTING,
  RESET_SCHEME_SETTINGS,
} from "../constans";

const initState = {};
const tabsSettingsReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case LOAD_TAB_SETTINGS: {
      return {
        ...state,
        [payload.currentTableId]: {
          ...payload.colorScheme,
          columnSchemes: payload.columnSchemes,
        },
      };
    }
    case SET_COLUMN_SCHEME: {
      const currentTab = state[payload.currentTableId];
      const currentTabColumnSchemes = state[payload.currentTableId]?.columnSchemes;
      if (payload.prevColumnName === payload.newColumnName) {
        return {
          ...state,
          [payload.currentTableId]: {
            ...currentTab,
            columnSchemes: {
              ...currentTabColumnSchemes,
              ...payload.columnSchemes,
            },
          },
        };
      }

      const filteredScheme = ObjectDeleteByKey({
        object: currentTabColumnSchemes,
        keyToDelete: payload.prevColumnName,
      });

      return {
        ...state,
        [payload.currentTableId]: {
          ...currentTab,
          columnSchemes: { ...filteredScheme, ...payload.columnSchemes },
        },
      };
    }
    case DELETE_COLUMN: {
      const currentTab = state[payload.currentTableId]
      const currentTabColumnSchemes = currentTab?.columnSchemes;
      const newColumnScheme = ObjectDeleteByKey({
        object: currentTabColumnSchemes,
        keyToDelete: payload.columnName,
      });
      return {
        ...state,
        [payload.currentTableId]: {
          ...currentTab,
          columnSchemes: newColumnScheme,
        },
      };
    }
    case CLEAR_TEMPORARY_SETTINGS: {
      return initState;
    }
    case SET_COLOR_PRIMARY_COLUMN: {
      const { currentColumnId, currentTableId } = payload;

      const {columnSchemes, ...currentTab} = state?.[currentTableId];

      const newTab = {};

      for (const key in currentTab) {
        const column = currentTab[key];

        if (currentColumnId !== key) {
          column.colorScheme.isPrimaryColumn = false;
        }
        newTab[key] = column;
      }

      return {
        ...state,
        [currentTableId]: {...newTab, columnSchemes},
      };
    }
    case CREATE_SETTING_COLOR_SCHEME: {
      const { columnId, currentTableId, colorScheme, uniqueColorsData } =
        payload;

      const currentTab = state?.[currentTableId];

      return {
        ...state,
        [currentTableId]: {
          ...currentTab,
          [columnId]: {
            colorScheme,
            uniqueColorsData,
          },
        },
      };
    }
    case RESET_SCHEME_SETTINGS: {
      return initState
    }
    case DELETE_SCHEME_SETTING: {
      const { columnName, currentTableId} = payload;
      const currentTab = state?.[currentTableId];

      const updatedTab = ObjectDeleteByKey({
        object: currentTab,
        keyToDelete: columnName,
      })

      return {
        ...state,
        [currentTableId]: {
          ...updatedTab
        }
      }
    }
    default:
      return state;
  }
};
export default tabsSettingsReducer;
